import { createFileRoute } from "@tanstack/react-router";

import RecordsPage from "~/pages/player/RecordsPage.tsx";

type RecordsSearchParams = {
    teamId?: string;
};

export const Route = createFileRoute("/_auth/records/")({
    // The router parses the search string as JSON, so `?teamId=5` arrives as a number.
    validateSearch: (search: Record<string, unknown>): RecordsSearchParams => ({
        teamId:
            typeof search.teamId === "string" || typeof search.teamId === "number" ? String(search.teamId) : undefined,
    }),
    component: RecordsPage,
});
